const fr = {
    "Politique": "Politique",
    "Économie": "Économie",
    "Environnement": "Environnement",
    "Droits": "Droits",
    "Santé": "Santé",
    "Éducation": "Éducation",
    "Inégalités": "Inégalités",
    "Social": "Social",
    "Technologies": "Technologies",
    "Sécurité": "Sécurité",
    "Agriculture": "Agriculture",
    "Mobilité": "Mobilité",
    "Justice": "Justice",
    "Humanité": "Humanité",
    "Société": "Société",
    "Culture": "Culture",
    "Sport": "Sport",
    "Autre": "Autre"
};

const es = {
    "Politique": "Política",
    "Économie": "Economía",
    "Environnement": "Medio ambiente",
    "Droits": "Derechos",
    "Santé": "Salud",
    "Éducation": "Educación",
    "Inégalités": "Desigualdades",
    "Social": "Social",
    "Technologies": "Tecnologías",
    "Sécurité": "Seguridad",
    "Agriculture": "Agricultura",
    "Mobilité": "Movilidad",
    "Justice": "Justicia",
    "Humanité": "Humanidad",
    "Société": "Sociedad",
    "Culture": "Cultura",
    "Sport": "Deporte",
    "Autre": "Otro"
}
const en = {
    "Politique": "Politics",
    "Économie": "Economy",
    "Environnement": "Environment",
    "Droits": "Rights",
    "Santé": "Health",
    "Éducation": "Education",
    "Inégalités": "Inequalities",
    "Social": "Social",
    "Technologies": "Technologies",
    "Sécurité": "Security",
    "Agriculture": "Agriculture",
    "Mobilité": "Mobility",
    "Justice": "Justice",
    "Humanité": "Humanity",
    "Société": "Society",
    "Culture": "Culture",
    "Sport": "Sport",
    "Autre": "Other"
}
const it = {
    "Politique": "Politica",
    "Économie": "Economia",
    "Environnement": "Ambiente",
    "Droits": "Diritti",
    "Santé": "Salute",
    "Éducation": "Educazione",
    "Inégalités": "Disuguaglianze",
    "Social": "Sociale",
    "Technologies": "Tecnologie",
    "Sécurité": "Sicurezza",
    "Agriculture": "Agricoltura",
    "Mobilité": "Mobilità",
    "Justice": "Giustizia",
    "Humanité": "Umanità",
    "Société": "Società",
    "Culture": "Cultura",
    "Sport": "Sport",
    "Autre": "Altro"
}
const pt = {
    "Politique": "Política",
    "Économie": "Economia",
    "Environnement": "Meio ambiente",
    "Droits": "Direitos",
    "Santé": "Saúde",
    "Éducation": "Educação",
    "Inégalités": "Desigualdades",
    "Social": "Social",
    "Technologies": "Tecnologias",
    "Sécurité": "Segurança",
    "Agriculture": "Agricultura",
    "Mobilité": "Mobilidade",
    "Justice": "Justiça",
    "Humanité": "Humanidade",
    "Société": "Sociedade",
    "Culture": "Cultura",
    "Sport": "Esporte",
    "Autre": "Outro"
}
const ja = {
    "Politique": "政治",
    "Économie": "経済",
    "Environnement": "環境",
    "Droits": "権利",
    "Santé": "健康",
    "Éducation": "教育",
    "Inégalités": "不平等",
    "Social": "社会",
    "Technologies": "テクノロジー",
    "Sécurité": "セキュリティ",
    "Agriculture": "農業",
    "Mobilité": "モビリティ",
    "Justice": "正義",
    "Humanité": "人類",
    "Société": "社会",
    "Culture": "文化",
    "Sport": "スポーツ",
    "Autre": "その他"
}
const nl = {
    "Politique": "Politiek",
    "Économie": "Economie",
    "Environnement": "Milieu",
    "Droits": "Rechten",
    "Santé": "Gezondheid",
    "Éducation": "Onderwijs",
    "Inégalités": "Ongelijkheid",
    "Social": "Sociaal",
    "Technologies": "Technologieën",
    "Sécurité": "Veiligheid",
    "Agriculture": "Landbouw",
    "Mobilité": "Mobiliteit",
    "Justice": "Justitie",
    "Humanité": "Mensheid",
    "Société": "Maatschappij",
    "Culture": "Cultuur",
    "Sport": "Sport",
    "Autre": "Andere"
}

const de = {
    "Politique": "Politik",
    "Économie": "Wirtschaft",
    "Environnement": "Umwelt",
    "Droits": "Rechte",
    "Santé": "Gesundheit",
    "Éducation": "Bildung",
    "Inégalités": "Ungleichheiten",
    "Social": "Sozial",
    "Technologies": "Technologien",
    "Sécurité": "Sicherheit",
    "Agriculture": "Landwirtschaft",
    "Mobilité": "Mobilität",
    "Justice": "Gerechtigkeit",
    "Humanité": "Menschlichkeit",
    "Société": "Gesellschaft",
    "Culture": "Kultur",
    "Sport": "Sport",
    "Autre": "Sonstiges"
}
// Exporter plusieurs objets
module.exports = { fr, es, en, it, pt, ja, nl, de };
